
import React, { Component } from 'react';

import { withRouter,Link } from "react-router-dom";
import "./index.scss";

class SideMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            title: this.props.title,
            dataList: this.props.data,
            tabListWidth: this.props.tabListWidth

        };

    }

    componentWillMount(){
        // 判断url，根据url显示左侧选中的位置
        var s = this.props.location.pathname;
        var path = s.substring(s.lastIndexOf("/")+1);
        console.log(path);
        if(path == 'announcements' || path == 'nationalPolicy' || path == 'elegantDemeanour'){
            this.setState({ active: 0 })
        }else if(path == 'hotNews' || path == 'localPolicy' || path == 'mostBeautiful'){
            this.setState({ active: 1 })
        }else if(path == 'soldierConsulting' || path == 'lawsRegulations' || path == 'documentary'){
            this.setState({ active: 2 })
        }else if(path == 'other' || path == 'policyInterpretation' || path == 'armyGotTalent'){
            this.setState({ active: 3 })
        }else if(path == 'armyLife'){
            this.setState({ active: 4 })
        }
    }

    handleClick(e,path) {
        let { dataList, active } = this.state;
        this.setState({
            active: e,
            type: dataList[e].type
        },()=>{this.props.history.push(path)});
    }



    render() {
        let { dataList, active, title, tabListWidth } = this.state;
        return (
            <div className="content_tab">
                <div className="tab_title">{title}</div>
                <div className="tab_list">
                    {dataList.map((item, index) => {
                        return (
                            <div key={index} className={active == index ? "current" : ""} style={{ width: (tabListWidth ? "140px" : "110px") }} onClick={() => this.handleClick(index,item.path)}>
                                <i></i>
                                <span></span>
                                <a to={item.path}>{item.txt}</a>
                            </div>
                        )
                    })}
                </div>
            </div>

        )
    }
}

export default withRouter(SideMenu);